import {
  fetchSettings,
  updateSetting,
  notifyCabinetSettingUpdate,
} from '../utils/api';

export const FETCH_SETTING_START = 'FETCH_SETTING_START';
export const FETCH_SETTING_RECEIVED = 'FETCH_SETTING_RECEIVED';
export const FETCH_sETTING_ERROR = 'FETCH_sETTING_ERROR';
export const UPDATE_SETTING_START = 'UPDATE_SETTING_START';
export const UPDATE_SETTING_SUCCESS = 'UPDATE_SETTING_SUCCESS';
export const UPDATE_SETTING_ERROR = 'UPDATE_SETTING_ERROR';

export const fetchCabinetSettings = deviceCode => async dispatch => {
  try {
    dispatch({
      type: FETCH_SETTING_START,
    });

    const settings = await fetchSettings(deviceCode);

    const {
      refillFilter,
      shelfConfigId,
    } = settings.data?.device?.alternativeIds;
    dispatch({
      type: FETCH_SETTING_RECEIVED,
      data: refillFilter || 'onlyRefilledItems',
      shelfConfigId: shelfConfigId || null,
    });
  } catch (error) {
    dispatch({
      type: FETCH_sETTING_ERROR,
      error: true,
    });
  }
};

export const updateCabinetSettings = (filter, deviceCode) => async dispatch => {
  try {
    dispatch({
      type: UPDATE_SETTING_START,
    });

    const setting = await updateSetting(deviceCode, filter);

    // the Root API answers with the merged settings; the filter is saved when it echoes back
    if (
      setting &&
      setting.settings &&
      setting.settings.refillFilter === filter
    ) {
      // notify cabinet that refill setting has changed
      notifyCabinetSettingUpdate(deviceCode);
      // on context that cabinet settings update takes appx. 10s,
      // notify user the cabinet is being updated meanwhile.
      setTimeout(() => {
        dispatch({
          type: UPDATE_SETTING_SUCCESS,
          data: filter,
        });
      }, 5000);
    }
  } catch (error) {
    dispatch({
      type: UPDATE_SETTING_ERROR,
      error: true,
    });
  }
};
